import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

export class FeedbackDTO {
    FeedbackID: number;
    CompanyID: number;
    Rating: number;
    Body: string;
    URL: string;
}

@Component({
    selector: 'cv-submit-feedback',
    templateUrl: './submit-feedback.component.html',
    styleUrl: './submit-feedback.component.scss'
})
export class SubmitFeedbackComponent implements OnInit{
    isSubmitting: boolean = false;
    isSubmitted: boolean = false;
    success: boolean = false;

    showRatingError: boolean = false;
    suppressReasonError: boolean = false;
    suppressEmailError: boolean = false;
    isError: boolean = false;

    sender: string = "";
    rating: number = -1;
    body: string = "";

    constructor(
      private navigationService: NavigationService,
      private activeModal: NgbActiveModal) { }

    ngOnInit() {
        this.initialize();
    }

    initialize(keepFormData: boolean = false){
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.success = false;
        this.showRatingError = false;
        if (!keepFormData) {
            this.sender = this.navigationService.loggedInEmail;
            this.rating = -1;
            this.body = "";
            this.suppressReasonError = true;
            if (this.sender === undefined) {
                this.suppressEmailError = true;
            }
        }
    }

    selectRating(rating: number){
        this.rating = rating;
        this.showRatingError = false;
    }

    validateForm(): boolean{
        let hasError = false;

        // validate rating (expression)
        if (this.rating < 0 || this.rating > 5) {
            hasError = true;
            this.showRatingError = true;
        } else {
            this.showRatingError = false;
        }

        // validate reason
        if (this.body.trim() === ""){
            hasError = true;
            this.suppressReasonError = false;
        }

        return !hasError;
    }

    onBodyChanged(){
        if(this.body.trim() !== ""){
            this.suppressReasonError = true;
        }
    }

    close(){
        this.activeModal.close();
    }

    async submitFeedback(){
        if (!this.validateForm()) {
            return;
        }

        this.isSubmitting = true;

        try{
            const response = await this.navigationService.submitFeedback(this.rating, this.body);
            if(response){
                this.isSubmitting = false;
                this.isSubmitted = true;
                this.success = true;
            }
        }
        catch{
            this.isSubmitting = false;
            this.isSubmitted = true;
            this.success = false;
        }
    }
}
